// extracted by mini-css-extract-plugin
export var buttonsContainer = "header-desktop-module--buttonsContainer--81eee";
export var genericContainer = "header-desktop-module--genericContainer--16248";
export var header = "header-desktop-module--header--8fa03";
export var headerItem = "header-desktop-module--headerItem--d0e54";
export var headerItemsContainer = "header-desktop-module--headerItemsContainer--eba4a";
export var itemPointer = "header-desktop-module--itemPointer--f324a";
export var link = "header-desktop-module--link--b0c7a";
export var menuItemsContainer = "header-desktop-module--menuItemsContainer--43651";
export var modalContent = "header-desktop-module--modalContent--04010";
export var navbar = "header-desktop-module--navbar--e0cef";
export var searchButton = "header-desktop-module--searchButton--95d2d";
export var subscribeButton = "header-desktop-module--subscribeButton--febcd";